import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import { Grid, Loader, RoundArrowButton, RoundArrowButtonDirection } from '@tfo/common'

import './StartIndividual.scss'
import { useHistory, useParams } from 'react-router-dom'
import $http from '../../../../utils/$http'
import { ApprovableOrderViewModel } from '../../ViewModels'
import LegitimateInterestAssessmentInformation from './LegitimateInterestAssessmentInformation'
import InsuranceDistributionDirectiveInformation from './InsuranceDistributionDirectiveInformation'
import SignatureInformation from './SignatureInformation'

import { ApprovalState } from '../../../../models/Enums'

interface QueryParams {
	orderId?: string
}

const StartIndividual: React.FunctionComponent<WrappedComponentProps> = props => {
	const params = useParams<QueryParams>()
	const history = useHistory()
	const orderId = parseInt(params.orderId)

	const [order, setOrder] = React.useState<ApprovableOrderViewModel>(null)
	const [isLoading, setIsLoading] = React.useState<boolean>(false)

	React.useEffect(() => {
		setIsLoading(true)
		$http.get<ApprovableOrderViewModel>(`order/${orderId}/approvable`)
			.then(o => {
				setOrder(o)
			})
			.catch(() => {
				console.error("failed fetching order")
				setOrder(null)
				//go ba
			})
			.finally(() => {
				setIsLoading(false)
			})
	}, [orderId])

	
	const hasOrder = !!order

	if(hasOrder) {
		order.approval = order.approval || {
			type: ApprovalState.LegitimateInterestAssessment,
			acceptanceMethod: order.approval.acceptanceMethod,
			canAccept: true
		}

		if(order?.isIDD) {
			order.approval.type = ApprovalState.InsuranceDistributionDirective;
		}
	}

	const approvalComponent = {
		[ApprovalState.InsuranceDistributionDirective]: 
			<InsuranceDistributionDirectiveInformation {...order} isLoading={isLoading} setIsLoading={setIsLoading} />,
		[ApprovalState.LegitimateInterestAssessment]: 
			<LegitimateInterestAssessmentInformation {...order} isLoading={isLoading} setIsLoading={setIsLoading} />,
		[ApprovalState.Signature]:
			<SignatureInformation {...order} />
	}

	return (
		<>
			{hasOrder && <Grid.GridWrapper className="IndividualView StartIndividual">
				<RoundArrowButton
					className='back-button'
					direction={RoundArrowButtonDirection.LEFT}
					onClick={() => history.push('/candidate')} />
				<IndividualHeader
					companyName={order.companyName}
					isBig
					headingId="startIndividual.heading1"
					subHeadingId="startIndividual.heading2"
					headingData={{
						individualFirstName: order.individualFirstName,
					}}
				/>
				{approvalComponent[order.approval.type]}
			</Grid.GridWrapper>}

			{isLoading && <Loader />}

		</>
	)
}

export default inject('rootStore')(injectIntl(observer(StartIndividual)))
